import src from "IMAGE";
export default { src, width: 108, height: 21, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAUxYnUEL19xBzhvgwYzZncFLVxtBC9fdQUyZHwFMmR3AAY1aHcELFhpBTNnegUvX20GL15uBS1bbAUuW3IELlxyIUgQoa/sqngAAAAASUVORK5CYII="};
